import React from 'react';

const AdminSkeleton: React.FC = () => {
    return (
        <div className="animate-pulse space-y-8">
            {/* Header Skeleton */}
            <div className="flex justify-between items-center mb-8">
                <div className="h-8 bg-brand-clay/10 rounded-lg w-48"></div>
                <div className="h-10 bg-brand-clay/10 rounded-xl w-32"></div>
            </div>

            {/* Stats Grid Skeleton */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="bg-white p-6 rounded-2xl border border-brand-clay/5 h-32 flex flex-col justify-center space-y-3">
                        <div className="h-4 bg-brand-clay/10 rounded w-1/2"></div>
                        <div className="h-8 bg-brand-clay/10 rounded w-3/4"></div>
                    </div>
                ))}
            </div>

            {/* Tabs Skeleton */}
            <div className="flex space-x-4 mb-8">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="h-10 bg-brand-clay/10 rounded-xl w-24"></div>
                ))}
            </div>

            {/* Content List Skeleton */}
            <div className="space-y-4">
                {[1, 2, 3, 4, 5].map((i) => (
                    <div key={i} className="bg-white p-4 rounded-xl border border-brand-clay/5 flex items-center space-x-4 h-24">
                        <div className="w-16 h-16 bg-brand-clay/10 rounded-lg shrink-0"></div>
                        <div className="flex-1 space-y-2">
                            <div className="h-4 bg-brand-clay/10 rounded w-1/3"></div>
                            <div className="h-3 bg-brand-clay/10 rounded w-1/4"></div>
                        </div>
                        <div className="flex space-x-2">
                            <div className="w-20 h-8 bg-brand-clay/10 rounded-lg"></div>
                            <div className="w-20 h-8 bg-brand-clay/10 rounded-lg"></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminSkeleton;
